import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useMediaQuery, useTheme } from '@mui/material';

import Button from '../../../../../Button';
import useStyles from './WarningClose.styles';
import { PublicRoutePath } from '../../../../../../utils/routes';

export interface WarningCloseProps {
  handleClose: () => void;
  handleContinue: () => void;
  isOpen: boolean;
}

function WarningClose({ handleClose, handleContinue, isOpen }: WarningCloseProps) {
  const { breakpoints } = useTheme();
  const fullScreen = useMediaQuery(breakpoints.down('sm'));
  const { classes } = useStyles();

  return (
    <Dialog
      PaperProps={{
        style: {
          backgroundColor: 'white',
        },
      }}
      fullScreen={fullScreen}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
    >
      <DialogTitle className={classes.title} id="customized-dialog-title">
        Discard your quote?
      </DialogTitle>
      <>
        <DialogContent className={classes.content}>Are you sure you want to stop getting a quote?</DialogContent>
        <DialogActions className={classes.actions}>
          <Button className={classes.button} onClick={handleClose}>
            No, go back
          </Button>
          <Button href={PublicRoutePath.HOME} className={classes.buttonClose} onClick={handleContinue}>
            Discard quote
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

export default WarningClose;
